import faLocale from 'element-ui/lib/locale/lang/fa' //引入element语言包 波斯语
const fa = {
  posterPage: {
    title1:'قابلیت اشتراک به زودی راه اندازی می شود!',
    title2:'تجدید اشتراک، ارتقاء امتیاز!',
    title3:'تخفیف انحصاری، تجدید هزینه ارزان تر',
    title4:'برای دریافت کد مبادله، می توانید با فروشندگان خرید تجهیزات مشورت کنید',
    title5:'اولویت تجربه',
    function1:'جزئیات عملکرد:',
    function2:'تجدید هزینه خدمات اساسی (مترجم همزمان، دستیار کنفرانس، دستیار هوشمند)',
    function3:'اشتراک در خدمات با ارزش افزوده (ترجمه آفلاین، ترجمه تماس های صوتی و ویدیویی)',
  },
  RedemptionCodePage: {
    RedemptionCode: 'تبدیل کد',
    ValueAddedServices: 'خدمات ارزش افزوده',
    UpgradedExperience: 'ارزش افزوده انحصاری، ارتقاء تجربه',
    OfflineTranslation: 'ترجمه آفلاین',
    NoInternet: 'بدون نیاز به اینترنت · ترجمه فوری · ایمن و قابل اعتماد',
    GoToSubscribe: 'اشتراک کنید',
    AudioAndVideoCall: 'تماس صوتی / ویدئویی',
    RealTimeCall: 'ترجمه صدا در زمان واقعی',
    BaseService: 'خدمات اساسی',
    AIAssistant: 'امکانات: ترجمه همزمان، دستیار کنفرانس، دستیار هوش مصنوعی',
    LanguagesSetting:'تنظیمات زبان',
    languages1:'چینی ساده',
    languages2:'چینی سنتی',
    languages3:'انگلیسی',
    languages4:'ژاپنی',
    languages5:'کره ای',
    languages6:'روسی',
    languages7:'اسپانیایی',
    languages8:'فرانسوی',
    languages9:'آلمانی',
    languages10:'پرتغالی',
    languages11:'ایتالیایی',
    languages12:'ترکی',
    languages13:'ویتنامی',
    languages14:'اندونزی',
    languages15:'هندی',
    languages16:'عربی',
    languages17:'تایلندی',
    languages18:'فارسی',
  },
  Login: {
    ToLogin: 'ورود',
    PhoneLogin: 'شماره تلفن همراه',
    EmailLogin: 'ورود ایمیل',
    PhonePlaceholder: 'لطفا شماره تلفن همراه خود را وارد کنید',
    EmailPlaceholder: 'Enter email',
    Code: 'کد تأیید',
    and: 'و',
    BeforeText: 'با ایجاد حساب شما موافقت و رعایت می کنید.',
    UserAgreement: 'توافقنامه کاربر',
    privacy: 'سیاست حفظ حریم خصوصی',
    errorMessage: 'کد تأیید اشتباه',
    readTitle: 'قرارداد زیر را بخوانید و موافقت کنید',
    readBefore: 'برای اطمینان از امنیت اطلاعات شخصی خود، لطفاً ابتدا مطالعه کنید و موافقت کنید.',
    cancel: 'لغو',
    agree: 'موافقت و ادامه',
    error1:'لطفا آدرس ایمیل معتبر را وارد کنید',
    error2:'لطفا شماره تلفن خود را وارد کنید',
    error3:'لطفا کد تایید را وارد کنید',
    success:'ورود موفق شد'
  },
  OffLinePage: {
    title: 'ترجمه آفلاین',
    NoInternet: 'بدون نیاز به اینترنت · ترجمه فوری · ایمن و قابل اعتماد',
    ServiceLife: 'مدت استفاده',
    forever: 'استفاده دائمی',
    describe: 'راهنمای اشتراک',
    describeItem1: '1.ویژگی ترجمه آفلاین یک بار پرداخت می شود، برای استفاده دائمی، استفاده از دستگاه بلوتوث را دنبال کنید، اگر دستگاه را جایگزین کنید، نیاز به اشتراک مجدد در کد مبادله ترجمه آفلاین دارید.',
    describeItem2: '2.پس از اشتراک کد مجوز، پرداخت قابل برگشت نیست.',
    describeItem3: '3. پشتیبانی از 10 زبان: چینی، انگلیسی، آلمانی، ژاپنی، کره ای، هندی، تایلندی، اسپانیایی، فرانسوی، روسی.',
    quantity: 'تعداد',
    payType: 'روش های پرداخت',
    card: 'کارت بانکی',
    wx: 'ویچت',
    GooglePay: 'Google Pay',
    subscribe: 'اشتراک',
    RMB: '¥',
    confirm:'تایید',
    cardNumber:'شماره کارت',
    periodOfValidity:'مدت اعتبار',
    safetyCode:'کد امنیتی',
    name:'نام',
    yearAndMonth:'سال/ماه',
    message1:'مقدار نباید صفر باشد.',
    popTip:'راهنمایی',
    popText1:'لطفا با دقت بخوانید و درک کنید.',
    popText2:'قرارداد پرداخت ترجمه آفلاین',
    popText3:'خواندم و موافقم',
    popText4:'خوانده و موافقت کرده',
  },
  AudioVideoPage: {
    title: 'تماس صوتی / ویدئویی',
    RealTime: 'ترجمه صدا در زمان واقعی',
    describe: 'راهنمای اشتراک',
    describeItem1: '1.ویژگی ترجمه تماس های صوتی و ویدیویی برای تعداد دقیقه های خرید شارژ، دقیقه ها از شروع تماس اتصال زمان محاسبه می شود، مجوز حساب را دنبال می کند، اگر وارد حساب دیگری شود، باید شارژ مجدد شود.',
    describeItem2: '2.اتصال و پیوند دستگاه های مختلف پس از بارگذاری حساب می تواند به طور معمول استفاده شود.',
    describeItem3: '3.ترجمه تماس های صوتی و ویدیویی پس از شارژ قابل برگشت نیست.',
    payType: 'روش های پرداخت',
    card: 'کارت بانکی',
    wx: 'ویچت',
    GooglePay: 'Google Pay',
    subscribe: 'اشتراک',
    RMB: '¥',
    sale: 'تخفیف',
    confirm:'تایید',
    time1:'ثانیه',
    time2:'دقیقه',
    time3:'ساعت',
    time4:'روز',
    time5:'ماه',
    time6:'سال',
  },
  OffLineResult: {
    title1: 'ترجمه آفلاین',
    title2: 'تماس صوتی / ویدئویی',
    title3: 'خدمات اساسی',
    success: 'اشتراک با موفقیت',
    fail:'خرابی در اشتراک',
    stock:'تبادل کد در دسترس است',
    saveTitle: 'کد مبادله را ذخیره کنید و برای مبادله به برنامه بروید',
    code: 'تبدیل کد',
    tip1: 'این کد فقط برای استفاده از ترجمه آفلاین استفاده می شود.',
    tip2: 'این کد فقط برای ترجمه تماس های صوتی / ویدیویی استفاده می شود',
    tip3: 'این کد فقط برای بازپرداخت مجدد خدمات اساسی استفاده می شود.',
    save: 'ذخیره‌سازی',
    time: 'زمان اشتراک:',
    copy: 'کپی کردن',
    copySuccess: 'کپی موفق شد',
    loading:'بارگذاری',
    paySuccess:'پرداخت موفق'
  },
  RedemptionList: {
    title: 'کد مبادله من',
    view: 'مشاهده',
    time: 'زمان اشتراک:',
  },
  MyRedemption: {
    title: 'کد مبادله من',
    code: 'تبدیل کد',
    time: 'زمان اشتراک:',
    copy: 'کپی کردن',
    tip1: 'این کد فقط برای استفاده از ترجمه آفلاین استفاده می شود.',
    tip2: 'این کد فقط برای ترجمه تماس های صوتی / ویدیویی استفاده می شود',
    tip3: 'این کد فقط برای بازپرداخت مجدد خدمات اساسی استفاده می شود.',
    save: 'ذخیره‌سازی',
    success:"عملیات موفق شد"
  },
  basePage:{
    error1:'اطلاعات محصول دریافت نشد',
    message1:'لطفا محصول را انتخاب کنید',
    title:'خدمات اساسی',
    function:'امکانات: ترجمه همزمان، دستیار کنفرانس، دستیار هوش مصنوعی',
    describe: 'راهنمای اشتراک',
    describe1:'1.پس از تجدید هزینه خدمات اساسی مانند مترجم و دستیار کنفرانس، تجهیزات معتبر را دنبال می کنند، اگر تجهیزات جایگزین شوند، مجدداً مجدد می شوند.',
    describe2:'2.پس از تجدید سرویس های اساسی، هزینه برگشت نمی شود.',
    payType: 'روش های پرداخت',
    card: 'کارت بانکی',
    wx: 'ویچت',
    GooglePay: 'Google Pay',
    subscribe: 'اشتراک',
    RMB: '¥',
    sale: 'تخفیف',
    month:'ماه',
    confirm:'تایید',
    month1:'1 ماه',
    month2:'نیم سال',
    month3:'یک سال'
  },
  ...faLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
// 导出
export default fa;
